import { styled } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';

interface ContainerProps {
  $isOpen?: boolean;
}

export const Container = styled(Box)({
  width: '100%',
  height: '100%',
  position: 'absolute',
  top: 0,
  left: 0,
  pointerEvents: 'none',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 100000,
});

export const Modal = styled(Box)<ContainerProps>(({ $isOpen }) => ({
  zIndex: 2000,
  position: 'relative',
  width: 'calc(100% - 48px)',
  maxWidth: 500,
  padding: '56px 16px 16px 16px',
  borderRadius: 10,
  backgroundColor: '#1C1D22',
  boxSizing: 'border-box',
  opacity: $isOpen ? 1 : 0,
  transform: $isOpen ? 'translateY(-40%) scale(1)' : 'translateY(200px) scale(0.9)',
  transition: 'all .25s ease-in-out',
  pointerEvents: $isOpen ? 'auto' : 'none',
}));

export const ErrorText = styled(Typography)({
  fontSize: 16,
  fontWeight: 400,
  lineHeight: '26px',
  whiteSpace: 'pre-line',
});

export const Close = styled('div')({
  position: 'absolute',
  right: 16,
  top: 16,
  cursor: 'pointer',
});
